// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","secondary":"_3gJIjMeAUTle7yKGEltNvw","textDefault":"#808080","inputWrapper":"_2jtDSQmiMxhf1Eo07lwklU","input":"_1cbTmBS464fIZl8e9o8LHP","border":"_3cpY7OYBwY9Dfk3AsBh44r","centered":"n8b-ZPcd_5TASYzDRQ8Y0","invalid":"_2ITvHOAZooKI4Fjat2_4_S","icon":"_1jL5FUpIg71xmZcSzi3k2b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Input/Input.mod.css
// module id = 1055
// module chunks = 0